module.exports = __webpack_public_path__ + "assets/img/shanghai_213_2.dbccfef4.jpg";